import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ViewChild, AfterViewInit , ViewChildren, Renderer2 } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UtilsService } from '../../../services/utils/utils.service';
import { ValidationDiscountService } from '../../../../core/providers/services/validation-discount/validation-discount.service';
import { CotizarService } from '../../../../core/providers/services/cotizar/cotizar.service';
import { RadioCardModel } from 'src/app/core/models/radio-card.model';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import { DocumentsService } from 'src/app/core/providers/services/documents/documents.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Numbers } from 'src/app/utils/constants';
import { ViajerosInterface } from 'src/app/core/models/cotizar.model';

@Component({
  selector: 'app-legal-step-one',
  templateUrl: './legal-step-one.component.html',
  styleUrls: ['./legal-step-one.component.scss']
})
export class LegalStepOneComponent implements OnInit, OnDestroy, AfterViewInit {

  //#region Constructor
  /**
   * constructor
   * @param vdSrv vdSrv
   * @param cotSrv cotSrv
   * @param utilsSrv utilsSrv
   * @param commons commons
   * @param document document
   * @param gtmService gtmService
   */
  constructor(
    private vdSrv: ValidationDiscountService,
    private cotSrv: CotizarService,
    private utilsSrv: UtilsService,
    private commons: CommonService,
    private document: DocumentsService,
    private gtmService: GoogleTagManagerService,
    private renderer: Renderer2
  ) {
    this.vdSrv = vdSrv;
    this.cotSrv = cotSrv;
    this.utilsSrv = utilsSrv;
    this.commons = commons;
    this.document = document;
    this.gtmService = gtmService;
    this.renderer = renderer;
  }

  @Input() formData: FormGroup;
  @Input() formConfig: any;
  @Input() clickBtnPos: string;

  @Output() clickBtn: EventEmitter<'back' | 'next'> = new EventEmitter();

  @ViewChild('chips', { static: false }) chips: any;
  @ViewChildren('select') selecter: any;

  finish = new Subject();
  currentStep = 0;
  idxDialog = 0;
  public dataModal: any = null;
  public showCompModal = false;
  displayCompModal: boolean;
  public showModal = false;
  displayModal: boolean;
  public showModal2 = false;
  displayModal2: boolean;
  public showModal3 = false;
  displayModal3: boolean;
  insureSelected: string;
  sobreprimasList: any[];
  formDataValue: any;
  unitfamiliar = false; // Se asigna si es unidad familiar
  numberOfInsuredMax = 0;
  hideGuaranteeTable = false;
  numberOfInsuredChange = false;
  errorNumberInsuredMax = false;
  checkPromoS = false;
  isOrigenSpain = true;
  showInsureType = false;
  countryDestinyMulti: boolean;
  maxDate: Date;
  promotionChange: { name: string, value: any };
  rentchange: { name: string, value: any, type: any };
  idProduct: number = Numbers.number0;
  idProduct1: number = Numbers.number0;
  idProduct2: number = Numbers.number0;
  patternNumber: RegExp = this.commons.patternsForm('number1');
  patternDecimalB1: RegExp = this.commons.patternsForm('dec1');
  documentsConst: any = {
    idProveedor: Numbers.number1,
    idPortal: Numbers.number1,
    productIPId: Numbers.number8,
    productNota: Numbers.number9,
    ipidName: 'document_ipid',
    notaName: 'document_nota'
  };
  /**
   * @ignore
   */
  ngOnInit() {
    localStorage.removeItem('layer1');
    localStorage.removeItem('layer2');
    localStorage.removeItem('s1Duration');
    sessionStorage.removeItem('radio-card');
    localStorage.removeItem('resetForm');

    this.currentStep = this.formConfig.currentStep.value;
    this.insureSelected = this.formConfig.codePromotional.linkFormPath[0];
    if (this.insureSelected === 'particularLegalAsistance') {
      this.idProduct1 = Numbers.number17048;
      this.idProduct2 = Numbers.number17049;
    }
    if (this.insureSelected === 'ownerLegalAsistance') {
      this.idProduct1 = Numbers.number17093;
      this.idProduct2 = Numbers.number17094;
    }
    const auxTypeValue: any = this.formData.get([this.insureSelected, 'insuranceType']).value;
    const auxDurationValue: any = this.formData.get([this.insureSelected, 'insuranceDuration']).value;

    if (auxTypeValue !== '') {
      this.idProduct = this.idProduct2;
      if (auxTypeValue.priority === 0) { this.idProduct = this.idProduct1; }
    }

    if (auxDurationValue !== '') {
      this.showInsureType = true;
      this.formDataValue = this.formData.get(this.insureSelected).value;
    }
    this.setValidator();
    this.initObs();
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    const linkToggle: NodeListOf<Element> = document.querySelectorAll('.js-toggle');
    linkToggle.forEach(element => {
      element.addEventListener('click', function(event: Event): void {
        event.preventDefault();
        const container: HTMLElement = document.getElementById(this.dataset.container);
        if (container.classList.contains('active')) {
          container.classList.add('inactive');
          container.classList.remove('active');
        } else {
          container.classList.add('active');
          container.classList.remove('inactive');
        }
      });
    });
  }
  /**
   * @ignore
   */
  ngOnDestroy() {
    this.finish.next(true);
  }

  /**
   * initObs
   */
  initObs(): void {
    // guardamos los valores del formulario en cada cambio
    this.formData.get(this.insureSelected).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
          this.formDataValue = this.formData.get(this.insureSelected).value;
        })
      ).subscribe();
    this.formData.get([this.insureSelected, 'dateEnd']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((el) => {
          if (el !== '') {
            setTimeout(() => {
              this.callCotizar();
            }, Numbers.number100);
          }
        })
      ).subscribe();

    this.formData.get([this.insureSelected, 'insuranceType']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((el: any) => {
          if (el !== null && el.priority === 0) {
            this.idProduct = this.idProduct1;
          }
          if (el === null && this.formDataValue.insuranceType !== '') {
            this.formData.get([this.insureSelected, 'insuranceType']).setValue(this.formDataValue.insuranceType);
          }
        })
      ).subscribe();
  }

  /**
   * clickButton
   * @param ev ev
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (this.formData.get([this.insureSelected, 'codePromotional']).value !== '') {
      this.checkCodePromotional2(this.formData.get([this.insureSelected, 'codePromotional']).value);
      setTimeout(() => {
        if (this.checkPromoS) {
          this.callCotizar();
          this.datalayer();
          this.clickBtn.emit(ev);
        }
      }, Numbers.number350);
    } else {
      this.callCotizar();
      this.datalayer();
      this.clickBtn.emit(ev);
    }
  }

  /**
   * openCoverage
   * @param ev ev
   */
  public openCoverage(ev: { radio: RadioCardModel, idx?: number }): void {
    this.dataModal = ev.radio;
    this.showCompModal = true;
    this.idxDialog = ev.idx + 1;
    this.showModalDialog();
  }

  /**
   * closeCoverage
   */
  public closeCoverage(): void {
    this.dataModal = null;
    this.showCompModal = false;
    this.idxDialog = 0;
  }

  /**
   * getModalState
   * @returns returns
   */
  public getModalState(): boolean  {
    return this.showCompModal;
  }

  /**
   * @description retorna si se muestra el modal condiciones
   * @returns boolean
   */
  public getModalState1(): boolean {
    return this.showModal;
  }
  /**
   * @description retorna si se muestra el modal número de asegurados
   * @returns boolean
   */
  public getModalState2(): boolean {
    return this.showModal2;
  }
  /**
   * @description retorna si se muestra el modal duración mínima
   * @returns boolean
   */
  public getModalState3(): boolean {
    return this.showModal3;
  }
  /**
   * @description modal de cobertura
   */
  showModalDialog(): void {
    this.displayCompModal = true;
    this.showCompModal = this.displayCompModal;
  }

  /**
   * checkCodePromotional
   * @param code code
   */
  checkCodePromotional(code: string): void {
    this.vdSrv.getCheckValidationCode(code)
      .pipe(take(1))
      .subscribe((codeStatus: any) => {
        if (!codeStatus) {
          this.promotionChange = { name: 'promo', value: 'error' };
        } else {
          this.callCotizar();
        }
      });
  }

  /**
   * checkCodePromotional2
   * @param code code
   */
  checkCodePromotional2(code: string): void {
    this.vdSrv.getCheckValidationCode(code)
      .pipe(take(1))
      .subscribe((codeStatus: any) => {
        if (!codeStatus) {
          this.promotionChange = { name: 'promo', value: 'error' };
        }
        this.checkPromoS = codeStatus;
      });
    setTimeout(() => {
      return this.checkPromoS;
    }, Numbers.number200);
  }

  /**
   * @description captura el valor y lanza búsqueda en servicio
   * @example
   * Comrpobar código promocional o precio de renta
   */
  dataEmit(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) { keyPress = ev; }
      if (keyPress !== null && keyPress.enter !== undefined && keyPress.enter) {
        const auxField: any = keyPress.field;
        const auxValue: any = this.formData.get(this.formConfig.codePromotional.linkFormPath).value;
        if (auxField !== undefined && auxField[1] === 'monthlyRent') {
          this.validRent();
        } else {
          this.checkCodePromotional(auxValue);
        }
      }
    }
  }

  /**
   * @description blur en input
   * @example
   * Comrpobar precio de renta
   */
  dataEmitBlur(event: any): void {
    let keyPress: any = null;
    if (Object.keys(event).length > 0) { keyPress = event; }
    const auxFieldName: any = keyPress.fieldName;
    if (auxFieldName === 'monthlyRent') {
      const auxFieldValue: any = this.formData.get(this.formConfig.monthlyRent.linkFormPath).value;
      if (auxFieldValue !== '' && this.formConfig.insuranceType1Aux !== null) {
        this.callCotizar();
      }
    }
  }

  /**
   * @description validar el monto de renta
   */
  validRent(): void {
    const fieldMax: number = this.formDataValue.insuranceType.priority;
    const auxField12 = parseInt(this.formData.get(this.formConfig.monthlyRent.linkFormPath).value,
      Numbers.number10) * Numbers.number12;
    if (fieldMax === 1 && auxField12 > Numbers.number60000) {
      this.rentchange = { name: 'rent', value: 'error', type: Numbers.number60 };
    } else if (fieldMax === 1) {
        this.rentchange = { name: 'rent', value: 'ok', type: Numbers.number60 };
    } else if (auxField12 > Numbers.number24000 && fieldMax === 0) {
      this.rentchange = { name: 'rent', value: 'error', type: Numbers.number24 };
    } else if (fieldMax === 0) {
      this.rentchange = { name: 'rent', value: 'ok', type: Numbers.number24 };
    } else {}
  }

  /**
   * downloadFileService
   * @param id id
   */
  downloadFileService(id: any): void {
    this.document.getAditinalDocument(id, this.documentsConst.idProveedor, this.documentsConst.idPortal,
      this.documentsConst.productIPId)
      .pipe(take(1))
      .subscribe((res) => {
        this.downloadFile(res, this.documentsConst.ipidName);
      });
  }

  /**
   * downloadFileServiceN
   * @param id id
   */
  downloadFileServiceN(id: any): void {
    this.document.getAditinalDocument(id, this.documentsConst.idProveedor, this.documentsConst.idPortal,
      this.documentsConst.productNota)
      .pipe(take(1))
      .subscribe((res) => {
        this.downloadFile(res, this.documentsConst.notaName);
      });
  }

  /**
   * downloadFile
   * @param item item
   * @param name name
   */
  downloadFile(item: any, name?: string): void {
    let filename: any;

    const file: Blob = this.commons.b64toBlob(item, 'application/pdf');
    filename = 'document';
    if (name !== '') { filename = name; }

    const linkElement: HTMLElement = this.renderer.createElement('a');
    this.renderer.setAttribute(linkElement, 'href', window.URL.createObjectURL(file));
    this.renderer.setAttribute(linkElement, 'download', filename);
    linkElement.dispatchEvent(new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    }));
    this.datalayer2(filename);
  }

  /**
   * @description asignar las validaciones del paso
   */
  public setValidator(): void {
    this.formData.get(this.formConfig.date.start.linkFormPath).setValidators([Validators.required]);
    this.formData.get(this.formConfig.date.end.linkFormPath).setValidators([Validators.required]);
    this.formData.get(this.formConfig.date.start.linkFormPath).updateValueAndValidity();
    this.formData.get(this.formConfig.date.end.linkFormPath).updateValueAndValidity();

    if (this.insureSelected === 'ownerLegalAsistance') {
      this.formData.get(this.formConfig.monthlyRent.linkFormPath).setValidators(
        [Validators.pattern(this.patternNumber), Validators.required]);
      this.formData.get(this.formConfig.monthlyRent.linkFormPath).updateValueAndValidity();
    }
  }

  /**
   * @description asignar la cotización
   */
  callCotizar(): void {
    let firstOpt: any;
    let secondOpt: any;
    let rentaA = 0;
    let expatriadoV = true;
    if (this.insureSelected === 'ownerLegalAsistance') {
      expatriadoV = false;
      rentaA = 0;
      if (this.formData.get(this.formConfig.monthlyRent.linkFormPath).value !== '') {
        rentaA = this.formData.get(this.formConfig.monthlyRent.linkFormPath).value;
      }
    }

    const viajerosBase: Partial<ViajerosInterface> = {
      idPresupuesto: 0,
      ambitoOrigen: this.formDataValue.countryOriginEnvironment,
      ambitoDestino: this.formDataValue.countryDestinyEnvironment,
      expatriado: expatriadoV,
      numDias: this.formDataValue.insuranceTime
    };
    const viajerosNormales: any = {
      ...viajerosBase,
      numViajeros: this.formDataValue.numberOfInsured,
      idSobrePrima: 0
    };
    const baseOpt: any = {
      fecefecto: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateStart),
      fecvencimiento: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateEnd),
      fectarificacion: this.utilsSrv.getDateToday(),
      procedencia: 'WEB',
      recargo: 0,
      descuentomediador: '0',
      idportal: '1',
      unidadfamiliar: '0',
      desdescuento: this.formDataValue.codePromotional,
      tipocobertura: 'Anual_+90',
      viajeros: [viajerosNormales],
      garantias: [],
      idProveedor: `${this.formDataValue.idCorreduria}`
    };

    if (this.insureSelected === 'ownerLegalAsistance') {
      firstOpt = {
        ...baseOpt,
        idproducto: `${this.idProduct1}`,
        renta: rentaA
      };

      secondOpt = {
        ...firstOpt,
        idproducto: `${this.idProduct2}`,
        renta: rentaA
      };
    } else {
      firstOpt = {
        ...baseOpt,
        idproducto: `${this.idProduct1}`
      };

      secondOpt = {
        ...firstOpt,
        idproducto: `${this.idProduct2}`
      };
    }

    const idx = 0;
    this.formConfig.insuranceType.radioCardList[idx].price = '';
    this.cotSrv.postQuotation(firstOpt)
      .pipe(
        take(1),
        tap((resp: any) => {
          const precioTotal = 'Precio_Total';
          this.formConfig.insuranceType.radioCardList[idx].price = resp[precioTotal].toFixed(Numbers.number2);
          this.formConfig.insuranceType.radioCardList[idx].budge = resp;
          this.formConfig.insuranceType0Aux = resp;

          // if (this.insureSelected === 'ownerLegalAsistance') {
          //   this.showInsureType = true;
          // }
        })
      ).subscribe();

    // if (this.insureSelected !== 'ownerLegalAsistance') {
    const idx2 = 1;
    this.formConfig.insuranceType.radioCardList[idx2].price = '';
    this.cotSrv.postQuotation(secondOpt)
      .pipe(
        take(1),
        tap((resp: any) => {
          const precioTotal = 'Precio_Total';
          this.formConfig.insuranceType.radioCardList[idx2].price = resp[precioTotal].toFixed(Numbers.number2);
          this.formConfig.insuranceType.radioCardList[idx2].budge = resp;
          this.formConfig.insuranceType1Aux = resp;
          this.showInsureType = true;
        })
      ).subscribe();
    // }
  }

  /**
   * @description asignar evento analítica
   */
  datalayer(): void {
    const formName: any = this.formData.get('insureSelected').value;
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'jurídico',
      paso: 't1'
    };
    this.gtmService.pushTag(datalayerD);
  }
  /**
   * @description asignar evento analítica - descargar documento
   */
  datalayer2(nameDoc: any): void {
    const nameDoc2: string = nameDoc.split(' ').join('_');
    const datalayerD: any = {
      event: 'ev_descarga',
      event_category: 'descarga',
      event_action: nameDoc2,
      event_label: '-'
    };
    this.gtmService.pushTag(datalayerD);
  }
}
